import { connect } from 'react-redux';
import InvestmentSumup from './InvestmentSumup';
import { RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  value: state.account.investment,
  minimum: state.investments.minAmount || state.investments.stockPrice,
  minimumPea: state.investments.minPeaAmount || 10000,
  taxRate: state.investments.taxRate,
  stockPrice: state.investments.stockPrice,
  valuation: state.investments.valuation,
});

export default connect(mapStateToProps)(InvestmentSumup);
